<app-button
  icon="flag" 
  size="small" 
  [title]="title"
  [style]="'text'"
  (onCLick)="onOpen()"
></app-button>

<app-adaptive-modal [title]="title" [showModal]="showModal">
  <div class="report-modal">
    <div class="report-modal_wrapper">
      <div class="report-modal_wrapper-block">
        <span class="title">Why are you reporting this content?</span>
        <span class="p3">
          Help us understand what’s wrong with this post. 
          Your report is anonymous and will be reviewed.
        </span>
      </div>
    
       <div class="report-modal_wrapper-block">
        <app-radio-button
          [inputGroup]="reportFGroup"
          fieldName="reason"
          [values]="reasonsList"
        ></app-radio-button>
       </div>
    
      <div class="report-modal_wrapper-block">
        <span class="p3">
          Provide any details that can help our team review 
          your report.
        </span>
        <app-input 
          mode="multiline"
          [inputGroup]="reportFGroup"
          fieldName="details"
          placeholder="Additional details (optional)"
          [showError]="false"
          style="min-width: 74px;"
        ></app-input>
      </div>
    </div>
  
    <div class="report-modal_button">
      <app-button
          title="Submit report"
          [style]="'filled stretch'"
          [default]="true"
          [disabled]="!reportFGroup.valid"
          (onCLick)="onSubmit()"
        ></app-button>
    </div>
  </div>
</app-adaptive-modal>

<app-modal-window 
  [showModal]="showReceivedNotify"
  [hideHeader]="true"
  [hasBackdrop]="true"
>
  <app-report-send-notify (onClose)="showReceivedNotify.next(false)"></app-report-send-notify>
</app-modal-window>